<template>
  <div style="min-height: 750px;" v-if="d_campaignWdm">
    <b-row>
      <b-col sm="12" lg="2"></b-col>
      <b-col sm="12" lg="8"></b-col>
      <b-col sm="12" lg="2"></b-col>
    </b-row>
    <b-row style="margin-bottom: 20px; border-bottom: solid 1px whitesmoke;">
      <b-col sm="12" md="2" lg="2"> </b-col>
      <b-col sm="12" md="4" lg="4">
        <i class="fa fa-desktop"></i>
        {{ StoreLangTranslation.data['shoplist'][StoreLang] }}
      </b-col>
      <b-col sm="12" md="4" lg="4" :style="StoreDevice.isMobile ? '' : 'text-align: right;'"></b-col>
      <b-col sm="12" md="2" lg="2"></b-col>
    </b-row>
    <b-row v-if="d_campaignWdm">
      <b-col sm="12" lg="2"></b-col>
      <b-col sm="12" lg="8">
        <b-row style="margin-bottom: 10px;">
          <b-col sm="12" lg="6"> </b-col>
          <b-col sm="12" lg="6" style="text-align: right;">
            <b-button size="sm" v-if="ClsUser.f_checkUserAuth(['admin'])" @click="f_openNewCampaignModal()" variant="primary">
              {{ StoreLangTranslation.data['new_campaign'][StoreLang] }}
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" lg="12">
            <b-form-input id="search" v-model="d_searchText" :placeholder="StoreLangTranslation.data['write_for_filtering'][StoreLang]"></b-form-input>
          </b-col>
        </b-row>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="2">
            <strong> Id </strong>
          </b-col>
          <b-col sm="12" lg="2">
            <strong> {{ d_campaignWdm['0']['parameters']['2']['name']['translation'][StoreLang] }} </strong>
          </b-col>
          <b-col sm="12" lg="2">
            <strong> {{ d_campaignWdm['0']['parameters']['1']['name']['translation'][StoreLang] }} </strong>
          </b-col>
          <b-col sm="12" lg="2">
            <strong> {{ d_campaignWdm['0']['parameters']['0']['name']['translation'][StoreLang] }} </strong>
          </b-col>
          <b-col sm="12" lg="2">
            <strong> {{ d_campaignWdm['0']['parameters']['3']['name']['translation'][StoreLang] }} </strong>
          </b-col>
          <!--           <b-col sm="12" lg="1">
            <strong> {{ d_campaignWdm['0']['parameters']['4']['name']['translation'][StoreLang] }} </strong>
          </b-col>
          <b-col sm="12" lg="1">
            <strong> {{ d_campaignWdm['0']['parameters']['5']['name']['translation'][StoreLang] }} </strong>
          </b-col>
          <b-col sm="12" lg="1">
            <strong> {{ d_campaignWdm['0']['parameters']['6']['name']['translation'][StoreLang] }} </strong>
          </b-col>
          <b-col sm="12" lg="1">
            <strong> {{ d_campaignWdm['0']['parameters']['7']['name']['translation'][StoreLang] }} </strong>
          </b-col>
          <b-col sm="12" lg="1">
            <strong> {{ d_campaignWdm['0']['parameters']['8']['name']['translation'][StoreLang] }} </strong>
          </b-col>
 -->
          <b-col sm="12" lg="1"> </b-col>
        </b-row>
        <b-row v-for="(usr_shp, usr_shp_ind) in d_campaignList" v-if="f_searchUserShop(usr_shp)" @mouseover="d_hoverIndex = usr_shp_ind" @mouseleave="d_hoverIndex = ''" :style="StoreDevice.isMobile ? 'cursor: pointer; margin: 10px; border-bottom: solid 1px #dcdcdc;' : 'cursor: pointer; margin: 1px; border-bottom: solid 1px #dcdcdc;'">
          <b-col sm="12" lg="2">
            <small style="color: blue;">{{ usr_shp.client_id }}</small>
          </b-col>
          <b-col sm="12" lg="2">
            <template v-if="usr_shp.data && usr_shp.data['0'] && usr_shp.data['0']['2'] && usr_shp.data['0']['2']['lang'] && usr_shp.data['0']['2']['lang'][StoreLang]">
              <img :src="usr_shp.data['0']['2']['lang'][StoreLang]" style="width: 50%">
            </template>
            <template v-else-if="usr_shp.data && usr_shp.data['0'] && usr_shp.data['0']['2'] && usr_shp.data['0']['2']['val']">
              <img :src="usr_shp.data['0']['2']['val']" style="width: 100%">
            </template>
          </b-col>
          <b-col sm="12" lg="2">
            <template v-if="usr_shp.data && usr_shp.data['0'] && usr_shp.data['0']['1'] && usr_shp.data['0']['1']['lang'] && usr_shp.data['0']['1']['lang'][StoreLang]">
              <span :style="d_hoverIndex === usr_shp_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ usr_shp.data['0']['1']['lang'][StoreLang] }}</span>
            </template>
            <template v-else-if="usr_shp.data && usr_shp.data['0'] && usr_shp.data['0']['1'] && usr_shp.data['0']['1']['val']">
              <span :style="d_hoverIndex === usr_shp_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ usr_shp.data['0']['1']['val'] }}</span>
            </template>
          </b-col>
          <b-col sm="12" lg="2">
            <template v-if="usr_shp.data && usr_shp.data['0'] && usr_shp.data['0']['0'] && usr_shp.data['0']['0']['val']['translation']">
              <span :style="d_hoverIndex === usr_shp_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ usr_shp.data['0']['0']['val']['translation'][StoreLang] }}</span>
            </template>
          </b-col>
          <b-col sm="12" lg="2">
            <template v-if="usr_shp.data && usr_shp.data['0'] && usr_shp.data['0']['3'] && usr_shp.data['0']['3']['lang'] && usr_shp.data['0']['3']['lang'][StoreLang]">
              <span :style="d_hoverIndex === usr_shp_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ usr_shp.data['0']['3']['lang'][StoreLang] }}</span>
            </template>
            <template v-else-if="usr_shp.data && usr_shp.data['0'] && usr_shp.data['0']['3'] && usr_shp.data['0']['3']['val']">
              <span :style="d_hoverIndex === usr_shp_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ usr_shp.data['0']['3']['val'] }}</span>
            </template>
          </b-col>
          <!-- 
          <b-col sm="12" lg="1">
            <template v-if="usr_shp.data && usr_shp.data['0'] && usr_shp.data['0']['4'] && usr_shp.data['0']['4']['lang'] && usr_shp.data['0']['4']['lang'][StoreLang]">
              <span :style="d_hoverIndex === usr_shp_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ usr_shp.data['0']['4']['lang'][StoreLang] }}</span>
            </template>
            <template v-else-if="usr_shp.data && usr_shp.data['0'] && usr_shp.data['0']['4'] && usr_shp.data['0']['4']['val']">
              <span :style="d_hoverIndex === usr_shp_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ usr_shp.data['0']['4']['val'] }}</span>
            </template>
          </b-col>
          <b-col sm="12" lg="1">
            <template v-if="usr_shp.data && usr_shp.data['0'] && usr_shp.data['0']['5'] && usr_shp.data['0']['5']['lang'] && usr_shp.data['0']['5']['lang'][StoreLang]">
              <span :style="d_hoverIndex === usr_shp_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ usr_shp.data['0']['5']['lang'][StoreLang] }}</span>
            </template>
            <template v-else-if="usr_shp.data && usr_shp.data['0'] && usr_shp.data['0']['5'] && usr_shp.data['0']['5']['val']">
              <span :style="d_hoverIndex === usr_shp_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ usr_shp.data['0']['5']['val'] }}</span>
            </template>
          </b-col>
          <b-col sm="12" lg="1">
            <template v-if="usr_shp.data && usr_shp.data['0'] && usr_shp.data['0']['6'] && usr_shp.data['0']['6']['lang'] && usr_shp.data['0']['6']['lang'][StoreLang]">
              <span :style="d_hoverIndex === usr_shp_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ usr_shp.data['0']['6']['lang'][StoreLang] }}</span>
            </template>
            <template v-else-if="usr_shp.data && usr_shp.data['0'] && usr_shp.data['0']['6'] && usr_shp.data['0']['6']['val']">
              <span :style="d_hoverIndex === usr_shp_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ usr_shp.data['0']['6']['val'] }}</span>
            </template>
          </b-col>
          <b-col sm="12" lg="1">
            <template v-if="usr_shp.data && usr_shp.data['0'] && usr_shp.data['0']['7'] && usr_shp.data['0']['7']['lang'] && usr_shp.data['0']['7']['lang'][StoreLang]">
              <span :style="d_hoverIndex === usr_shp_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ usr_shp.data['0']['7']['lang'][StoreLang] }}</span>
            </template>
            <template v-else-if="usr_shp.data && usr_shp.data['0'] && usr_shp.data['0']['7'] && usr_shp.data['0']['7']['val']">
              <span :style="d_hoverIndex === usr_shp_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ usr_shp.data['0']['7']['val'] }}</span>
            </template>
          </b-col>
          <b-col sm="12" lg="1">
            <template v-if="usr_shp.data && usr_shp.data['0'] && usr_shp.data['0']['8'] && usr_shp.data['0']['8']['lang'] && usr_shp.data['0']['8']['lang'][StoreLang]">
              <span :style="d_hoverIndex === usr_shp_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ usr_shp.data['0']['8']['lang'][StoreLang] }}</span>
            </template>
            <template v-else-if="usr_shp.data && usr_shp.data['0'] && usr_shp.data['0']['8'] && usr_shp.data['0']['8']['val']">
              <span :style="d_hoverIndex === usr_shp_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ usr_shp.data['0']['8']['val'] }}</span>
            </template>
          </b-col>
           -->
          <b-col sm="12" lg="1">
            <!-- <b-dropdown variant="white" size="sm" style="width: 100%; float: left;">
              <template slot="button-content">
                işlem
              </template>
              <b-dropdown-item v-if="ClsUser.f_checkUserAuth(['admin', 'shop_admin', 'shop_settings_edit']) || ClsUser.f_checkUserAuth([usr_shp.client_id + 'shop_admin', usr_shp.client_id + 'shop_settings_edit'], 'with_id')" @click="f_editThisUserShop(usr_shp.client_id)"><i class="fa fa-edit"></i> {{ StoreLangTranslation.data['edit'][StoreLang] }} </b-dropdown-item>
              <b-dropdown-item v-if="ClsUser.f_checkUserAuth(['admin', 'shop_admin', 'shop_bundle_add_edit']) || ClsUser.f_checkUserAuth([usr_shp.client_id + '_shop_admin', usr_shp.client_id + '_shop_bundle_add_edit'], 'with_id')" @click="f_newUserShopBundle(usr_shp.client_id)"><i class="fa fa-plus"></i> {{ StoreLangTranslation.data['create_new_product_bundle'][StoreLang] }} </b-dropdown-item>
              <b-dropdown-item v-if="ClsUser.f_checkUserAuth(['admin', 'shop_admin', 'shop_bundle_add_edit']) || ClsUser.f_checkUserAuth([usr_shp.client_id + '_shop_admin', usr_shp.client_id + '_shop_bundle_add_edit'], 'with_id')" @click="f_userShopBundleList(usr_shp.client_id)"><i class="fa fa-list"></i> {{ StoreLangTranslation.data['user_shop_bundle_list'][StoreLang] }} </b-dropdown-item>
              <b-dropdown-item v-if="ClsUser.f_checkUserAuth(['admin', 'shop_admin', 'shop_bundle_add_edit']) || ClsUser.f_checkUserAuth([usr_shp.client_id + '_shop_admin', usr_shp.client_id + '_shop_bundle_add_edit'], 'with_id')" @click="f_userShopBundleManage(usr_shp.client_id)"><i class="fa fa-list"></i> {{ StoreLangTranslation.data['user_shop_bundle_manage'][StoreLang] }} </b-dropdown-item>
              <b-dropdown-item v-if="ClsUser.f_checkUserAuth(['admin', 'shop_admin'])" @click="f_userShopOrderList(usr_shp.client_id)"><i class="fa fa-list"></i> {{ StoreLangTranslation.data['user_shop_order_list'][StoreLang] }} </b-dropdown-item>
              <b-dropdown-item v-if="ClsUser.f_checkUserAuth(['admin', 'shop_admin', 'shop_bundle_add_edit']) || ClsUser.f_checkUserAuth([usr_shp.client_id + '_shop_admin', usr_shp.client_id + '_shop_bundle_add_edit'], 'with_id')" @click="f_openNewCampaignModal(usr_shp.client_id)"><i class="fa fa-list"></i> {{ StoreLangTranslation.data['shop_bundle_update_by_excel'][StoreLang] }} </b-dropdown-item>
            </b-dropdown> -->
          </b-col>
        </b-row>
      </b-col>
      <b-col sm="12" lg="2"></b-col>
    </b-row>

    <b-modal v-if="d_editOrNewCampainModal.show" id="d_editOrNewCampainModal.show" v-model="d_editOrNewCampainModal.show" scrollable hide-footer :title="StoreLangTranslation.data['create_query_rule'][StoreLang]" centered header-bg-variant="info" header-text-variant="dark" size="xl">
      <div style="min-height: 500px;">
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_campaignWdm['0']['parameters']['0']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <select class="form-control" v-model="d_campaignData.status">
              <option v-for="(op, op_index) in d_campaignWdm['0']['parameters']['0'].options" :value="op.value">
                {{ op.translation[StoreLang] }}
              </option>
            </select>
          </b-col>
        </b-row>
        <hr/>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_campaignWdm['0']['parameters']['2']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
          </b-col>
        </b-row>
        <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
          <b-col sm="12" lg="1">
            {{ lang.label }}
          </b-col>
          <b-col sm="12" lg="11">
            <b-form-textarea type="text" v-model="d_campaignData.campaign_name[lang.label]"></b-form-textarea>
          </b-col>
        </b-row>
        <hr/>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_campaignWdm['0']['parameters']['3']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
          </b-col>
        </b-row>
        <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
          <b-col sm="12" lg="1">
            {{ lang.label }}
          </b-col>
          <b-col sm="12" lg="11">
            <b-textarea type="text" v-model="d_campaignData.campaign_mail_subject[lang.label]"></b-textarea>
          </b-col>
        </b-row>
        <hr/>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_campaignWdm['0']['parameters']['4']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
          </b-col>
        </b-row>
        <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
          <b-col sm="12" lg="1">
            {{ lang.label }}
          </b-col>
          <b-col sm="12" lg="11">
            <b-row>
              <b-col cols="12">
                <b-button :class="{ active: d_inputEditorMode === 'html' }"  variant="outline-secondary" @click="f_changeInputEditorMode('html')" style="font-size: 14px; margin-right: 2px;">{{ StoreLangTranslation.data['html_editor'][StoreLang] }}</b-button>
                <b-button :class="{ active: d_inputEditorMode === 'text' }"  variant="outline-secondary" @click="f_changeInputEditorMode('text', d_campaignData)" style="font-size: 14px;">{{ StoreLangTranslation.data['text_editor'][StoreLang] }}</b-button>
              </b-col>
            </b-row>
            <!-- <template v-if="d_campaignData.campaign_mail_content && d_campaignData.campaign_mail_content[lang.label]"> -->
            <template>
              <template v-if="d_inputEditorMode == 'text'">
                <b-textarea v-model="d_campaignData.campaign_mail_content[lang.label]" style="height: 300px;"></b-textarea>
              </template>
              <template v-else-if="d_inputEditorMode == 'html'">
                <html-editor :key="lang_index" :p_html_text="d_campaignData.campaign_mail_content[lang.label]" :p_htmlElementId="'website_html_edit_campaign_mail_content_' + lang.label"></html-editor>
              </template>
            </template>
          </b-col>
        </b-row>
        <hr/>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_campaignWdm['0']['parameters']['11']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <select class="form-control" v-model="d_campaignData.campaign_period_type">
              <option v-for="(op, op_index) in d_campaignWdm['0']['parameters']['11'].options" :value="op.value">
                {{ op.translation[StoreLang] }}
              </option>
            </select>
          </b-col>
        </b-row>
        <hr/>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_campaignWdm['0']['parameters']['1']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <input type="date" class="form-control" v-model="d_campaignData.campaign_start_date">
          </b-col>
        </b-row>
        <hr/>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_campaignWdm['0']['parameters']['10']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <input type="date" class="form-control" v-model="d_campaignData.campaign_end_date">
          </b-col>
        </b-row>
        <hr/>


        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_campaignWdm['0']['parameters']['5']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <b-input type="number" v-model="d_campaignData.campaign_mail_sending_start_time"></b-input>
          </b-col>
        </b-row>
        <hr/>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_campaignWdm['0']['parameters']['6']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <b-input type="number" v-model="d_campaignData.campaign_mail_sending_end_time"></b-input>
          </b-col>
        </b-row>
        <hr/>



        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_campaignWdm['0']['parameters']['7']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <select class="form-control" v-model="d_campaignData.campaign_query_type">
              <option v-for="(op, op_index) in d_campaignWdm['0']['parameters']['7'].options" :value="op.value">
                {{ op.translation[StoreLang] }}
              </option>
            </select>
          </b-col>
        </b-row>
        <hr/>
        <template v-if="d_campaignData.campaign_query_type == '0'">
          <wdm-rule-a :data_type="d_dbQueryRule.data_type" :option_data="d_dbQueryRule.option_data" :prepare_data="d_dbQueryRule.prepare_data" :query_list="d_dbQueryRule.query_list" :compile_str_array="d_dbQueryRule.compile_str_array" :compile_str_date="d_dbQueryRule.compile_str_date" :wdmr_change="d_dbQueryRule.wdmr_change" :p_wdmList="d_dbQueryRule.wdm_list" :mother_children="d_dbQueryRule.mother_children" :p_wdmParameterSelectData="d_dbQueryRule.wps_data" :p_wdmRuleAsettings="d_dbQueryRule.wra_settings" :compile_str_text="d_dbQueryRule.compile_str_text"></wdm-rule-a>
          <hr/>
        </template>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="6"></b-col>
          <b-col sm="12" lg="3">
            <b-button variant="outline-primary" size="sm" @click="d_editOrNewCampainModal.show = false">
              <i class="fa fa-send-o"></i> {{ StoreLangTranslation.data['cancel'][StoreLang] }}
            </b-button>
          </b-col>
          <b-col sm="12" lg="3">
            <b-button variant="outline-primary" size="sm" @click="f_acceptMainRule()">
              <i class="fa fa-send-o"></i> {{ StoreLangTranslation.data['save'][StoreLang] }}
            </b-button>
          </b-col>
        </b-row>

        {{ d_campaignData }}
      </div>
    </b-modal>

  </div>
</template>

<script>

import { ClsUser } from '@/wam/modules/user';
import { ClsRule } from '@/wam/modules/rule';
import { ClsWdm } from '@/wam/modules/wdm';
import { ClsRoute } from '@/wam/modules/route';
import store from '@/store';
import { ServiceFunctions } from '@/wam/modules/service';
import {
  default as PageInfo
} from '@/components/widgets/PageInfo';
import {
  default as WisdomDataModal
} from '@/wam/components/wdmr/WisdomDataModal';
import {
  default as RuleQuery
} from '@/wam/components/rule/RuleQuery';
import {
  default as WisdomDataShow
} from '@/wam/components/wdmr/WisdomDataShow';
import {
  default as WdmRuleA
} from '@/wam/components/rule/WdmRuleA';
import {
  default as HtmlEditor
} from '@/wam/components/widgets/HtmlEditor';
import { mapGetters } from 'vuex';
export default {
  name: 'campaign_management',
  computed: mapGetters({
    StoreDevice: 'StoreDevice',
    StoreLang: 'StoreLang',
    StoreLangList: 'StoreLangList',
    StoreLangTranslation: 'StoreLangTranslation',
    StoreFrontendSettings: 'StoreFrontendSettings',
  }),
  components: {
    PageInfo,
    WisdomDataModal,
    WisdomDataShow,
    WdmRuleA,
    RuleQuery,
    HtmlEditor,
  },
  props: {},
  data () {
    return {
      d_loadingSystemUpdate: false,
      d_editOrNewCampainModal: {
        'show': false,
        'campaign_client_id': ''
      },
      d_excelFileBase64: '',
      d_tmpFile: null,
      d_user: '',
      d_hoverIndex: '',
      d_searchText: '',
      d_frontendClientID: '',
      d_frontendList: [],
      d_campaignList: [],
      d_campaignWdm: '',
      d_campaignmailWdm: '',
      ClsUser: ClsUser,
      
      // d_editOrNewCampainModal.show: false,
      d_dataLoading: false,
      d_dbQueryRule: {
        'query_list': [],
        'compile_str_array': '',
        'compile_str_date': '',
        'compile_str_text': '',
      },
      d_prepareRuleNew: {
        'mother_children': {
          'change_status': 0,
          'forceUpdate': 0
        },
        'date_ability': '',
        'wdmr_change': { 'rule': 0 },
        'data_type': '',
        'option_data': {},
        'prepare_data': {},
        'query_list': [],
        'compile_str_date': [],
        'compile_str_text': [],
        'compile_str_array': [],
        'wra_settings': {
          'mode': 'param',
          'options': [
            { 'label': 'PARAM', 'value': 'param' },
            { 'label': 'PARAM & QUERY', 'value': 'param_query' }
          ]
        },
        'wps_data': [{
          'operation': '',
          'selected_value': '',
          'loc': [],
          'val_list': [],
          'selected_wdm': '',
          'd_level': 0,
          'd_level_count': 0,
          'significant': 'true'
        }],
        'wdm_list': [],
      },
      d_selectedLayerCode: 'campaignmail',
      d_temp: {},


      d_campaignData: {
        'status': '',
        'campaign_start_date': '',
        'campaign_name': {
          'tr': '',
          'en': ''
        },
        'campaign_mail_subject': {
          'tr': '',
          'en': ''
        },
        'campaign_mail_content': {
          'tr': '',
          'en': ''
        },
        'campaign_mail_sending_start_time': '',
        'campaign_mail_sending_end_time': '',
        'campaign_query_type': '',
        'campaign_mail_filter': '',
        'json_content': '',
        'campaign_end_date': '',
        'campaign_period_type': '0',
      },
      d_htmlParameters: [
        'campaign_mail_content',
      ],
      d_inputEditorMode: 'html',

    };
  },
  created: function () {
    ClsWdm.getLayerWdm('campaign').then(resp_wdm_data => { this.d_campaignWdm = resp_wdm_data; });
    ClsWdm.getLayerWdm('campaignmail').then(resp_wdm_data => { this.d_campaignmailWdm = resp_wdm_data; });
    this.d_user = JSON.parse(localStorage.getItem('user'));
    let auth_eligible = false;
    if (this.$route.meta && this.$route.meta.permission && this.$route.meta.permission.length > 0) {
      auth_eligible = ClsUser.f_checkUserAuth(this.$route.meta.permission, 'without_id');
    }
    if (this.d_user && this.d_user.username && auth_eligible) {
      this.f_userShopList();
    } else {
      this.$router.push({ path: this.StoreLangTranslation.data['page_404_path'][this.StoreLang], query: {} });
    }
  },
  beforeMount () {},
  mounted: function () {
    // console.log(this.StoreFrontendSettings);
    // console.log(this.d_campaignWdm);
  },
  methods: {
    f_changeInputEditorMode: function(editor_mode, param_location){
      if(editor_mode == "text"){
        for (let lang of this.StoreLangList.data) {
          for (let html_param of this.d_htmlParameters) {
            let div_el = document.getElementById("website_html_edit_" + html_param + '_' + lang.label);
            param_location[html_param][lang.label] = div_el.innerHTML;
          }
        }
      }
      setTimeout(function () {
        this.d_inputEditorMode = editor_mode;
      }.bind(this), 50);
    },
    f_acceptMainRule: function () {
      let parenthesis_control = ClsRule.f_controlParanthesisDesign(this.d_dbQueryRule.compile_str_array);
      // console.log('parenthesis_control : ', parenthesis_control);
      if (parenthesis_control) {
        if (this.d_dbQueryRule.wra_settings.mode === 'param') {
          ClsRule.f_paramToQuery(this.d_dbQueryRule.query_list, this.d_dbQueryRule.compile_str_array, this.d_dbQueryRule.wps_data);
        }
        this.d_ruleQueryData = {
          'query_list': this.d_dbQueryRule.query_list,
          'compile_str_array': this.d_dbQueryRule.compile_str_array,
          'compile_str_date': this.d_dbQueryRule.compile_str_date,
          'compile_str_text': this.d_dbQueryRule.compile_str_text
        };
        this.d_temp = {
          'query_list': this.d_dbQueryRule.query_list,
          'compile_str_array': this.d_dbQueryRule.compile_str_array,
          'compile_str_date': this.d_dbQueryRule.compile_str_date,
          'compile_str_text': this.d_dbQueryRule.compile_str_text
        };

        // let query = '';
        // let data = {
        //   'rule_data': this.d_ruleQueryData,
        //   'wdmr_list_id': '',
        //   'wdmr_list_id_count': '',
        //   'layer_code': this.d_selectedLayerCode,
        // };

        // this.d_dataLoading = true;
        // ServiceFunctions.db_layer_query(query, data)
        //   .then(resp => {
        //     this.d_dataList = [];
        //     this.d_dataLoading = false;
        //     if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
        //       for (let i in resp.data.sql_result_list['paramorder']) {
        //         this.d_dataList.push(resp.data.sql_result_list['parameters'][resp.data.sql_result_list['paramorder'][i]]);
        //       }
        //     } else {
        //       alert(resp.data.status_code + ' = ' + resp.data.status_message);
        //     }
        //   });

        // console.log('this.d_ruleQueryData ', this.d_ruleQueryData);

        let query = '';
        let data = {
          'rule_data': this.d_ruleQueryData,
          'campaign_data': this.d_campaignData,
        };

        // this.d_dataLoading = true;
        ServiceFunctions.campaign_record(query, data)
          .then(resp => {
            if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
              this.f_userShopList();
            } else {
              alert(resp.data.status_code + ' = ' + resp.data.status_message);
            }
          });







        this.d_editOrNewCampainModal.show = false;
      } else {
        alert(this.StoreLangTranslation.data['please_check_parenthesis'][this.StoreLang]);
      }
    },

    f_openSearchRuleModal: function () {
      this.d_dbQueryRule = JSON.parse(JSON.stringify(this.d_prepareRuleNew));
      let new_wdm_item = {'type': this.d_selectedLayerCode, 'value': this.d_selectedLayerCode, 'label': this.d_selectedLayerCode};
      this.d_dbQueryRule.wdm_list.push(new_wdm_item);
      this.d_dbQueryRule.option_data[this.d_selectedLayerCode] = this.d_campaignmailWdm;
      this.$set(this.d_dbQueryRule, 'query_list', this.d_temp.query_list || []);
      this.$set(this.d_dbQueryRule, 'compile_str_array', this.d_temp.compile_str_array || []);
      this.$set(this.d_dbQueryRule, 'compile_str_date', this.d_temp.compile_str_date || []);
      this.$set(this.d_dbQueryRule, 'compile_str_text', this.d_temp.compile_str_text || []);
      this.d_editOrNewCampainModal.show = true;
    },


    f_openNewCampaignModal: function () {
      // this.d_editOrNewCampainModal.show = true;
      this.f_openSearchRuleModal();
      this.d_editOrNewCampainModal.campaign_client_id = '';
    },
    f_selectExcelDocument: function () {
      if (this.d_tmpFile) {
        // console.log(this.d_tmpFile);
        let file_name = this.d_tmpFile.name;
        let arr = this.d_tmpFile.name.split('.');
        let fileExtension = arr[arr.length - 1];
        if (['xlsx'].indexOf(fileExtension.toLowerCase()) === -1) {
          this.d_tmpFile = null;
          this.$forceUpdate();
          alert(this.StoreLangTranslation.data['file_extension_type_is_not_eligible'][this.StoreLang]);
          return;
        }
        if (this.d_tmpFile.size > 10485760) {
          this.d_tmpFile = null;
          this.$forceUpdate();
          alert(this.StoreLangTranslation.data['file_size_is_not_eligible'][this.StoreLang], ' : ', this.d_tmpFile.size);
          return;
        }
        var reader = new FileReader();
        var vm = this;
        var reader = new FileReader();
        reader.addEventListener("load", function () {
          // console.log(reader.result);
          // console.log('page_info_index ', page_info_index);
          // console.log('page_info_detail_index ', page_info_detail_index);
          // console.log('vm.d_frdWebunitData.page_info ', vm.d_frdWebunitData.page_info);
          vm.d_excelFileBase64 = reader.result;
          vm.$forceUpdate();
          // vm.f_applyFrontendSettings();
        }, false);
        reader.readAsDataURL(this.d_tmpFile);
        this.d_tmpFile = null;
        this.$forceUpdate();
      }
    },
    f_createAcceptedDocumentTypes: function () {
      let accept = '';
      let file_types = ['xlsx'];
      for (let i in file_types) {
        accept += '.' + file_types[i] + ',';
      }
      return accept;
    },
    f_newUserShop: function () {
      this.$router.push({ path: ClsRoute.f_getRoutePath('user_shop_record', this.StoreLang), query: {} });
    },
    f_newUserShopBundle: function (user_shop_client_id) {
      this.$router.push({ path: ClsRoute.f_getRoutePath('user_shop_bundle_record', this.StoreLang), query: { 'user_shop_client_id': user_shop_client_id } });
    },
    f_userShopBundleList: function (user_shop_client_id) {
      this.$router.push({ path: ClsRoute.f_getRoutePath('user_shop_bundle_list', this.StoreLang), query: { 'user_shop_client_id': user_shop_client_id } });
    },
    f_userShopBundleManage: function (user_shop_client_id) {
      this.$router.push({ path: ClsRoute.f_getRoutePath('user_shop_bundle_manage', this.StoreLang), query: { 'user_shop_client_id': user_shop_client_id } });
    },
    f_userShopOrderList: function (user_shop_client_id) {
      this.$router.push({ path: ClsRoute.f_getRoutePath('user_shop_order_list', this.StoreLang), query: { 'user_shop_client_id': user_shop_client_id } });
    },
    f_editThisUserShop: function (user_shop_client_id) {
      let route_path = ClsRoute.f_getRoutePath('user_shop_record', this.StoreLang);
      // console.log('route_path : ', route_path);
      this.$router.push({ path: route_path, query: { 'user_shop_client_id': user_shop_client_id } });
    },
    f_searchUserShop: function (usr_shp) {
      let res = false;
      if (this.d_searchText) {
        if (usr_shp.w_id.toLocaleLowerCase().indexOf(this.d_searchText.toLocaleLowerCase()) !== -1) {
          res = true;
        }
      } else {
        res = true;
      }
      return res;
    },
    f_userShopList: function () {
      let query = '';
      let data = {};
      ServiceFunctions.campaign_list(query, data)
        .then(resp => {
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.list) {
              this.d_campaignList = resp.data.list;
            } else {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
  },
  watch: {}
};

</script>

